// A Text card's tile colours, in Studio and on the dashboard or report.
// Absent is the card's own surface and text colour.
export const TEXT_BACKGROUND_COLORS: Record<
  Studio.TextBackground,
  { background: string; color: string }
> = {
  inverted: {
    background: 'var(--color-text-card-inverted-bg)',
    color: 'var(--color-text-card-inverted-text)',
  },
  subtle: {
    background: 'var(--color-text-card-subtle-bg)',
    color: 'var(--color-text-card-subtle-text)',
  },
};

export const TEXT_BACKGROUND_LABELS: Record<Studio.TextBackground, string> = {
  inverted: 'Inverted',
  subtle: 'Subtle',
};

// The tile's colours, with the primary text colour pointed at its own so
// what sets that itself (Quill's editor, the Markdown) follows it too
type TileStyle = React.CSSProperties & { '--color-text-primary'?: string };

export const getTextBackgroundStyle = (
  background: Studio.TextBackground | undefined,
): TileStyle | undefined => {
  if (!background) {
    return undefined;
  }
  const colors = TEXT_BACKGROUND_COLORS[background];
  return { ...colors, '--color-text-primary': colors.color };
};
